/* eslint-disable no-unused-vars */
/* eslint-disable prefer-template */
/* eslint-disable spaced-comment */
/* eslint-disable no-console */
/* eslint-disable no-else-return */
/* eslint-disable no-useless-return */
/* eslint-disable consistent-return */
/* eslint-disable no-plusplus */
const basicCJKRegex = new RegExp(/[\u4E00-\u9FFF\u3400-\u4DBF\u3000-\u303F\u3105-\u3129\u02CA\u02C7\u02CB\u02D9]/);
const hasCJK = (s = '', extended = false) => {
  const extendedRegex = /[\u4E00-\u9FCC\u3400-\u4DB5\uFA0E\uFA0F\uFA11\uFA13\uFA14\uFA1F\uFA21\uFA23\uFA24\uFA27-\uFA29]|[\ud840-\ud868][\udc00-\udfff]|\ud869[\udc00-\uded6\udf00-\udfff]|[\ud86a-\ud86c][\udc00-\udfff]|\ud86d[\udc00-\udf34\udf40-\udfff]|\ud86e[\udc00-\udc1d]/;
  return s.search(extended ? extendedRegex : basicCJKRegex) > -1;
};

const halfSpaceLength = (s = '', length) => {
  let runningLength = 0;
  for (let i = 0; i < s.length; i += 1) {
    const c = s[i];
    const cLength = hasCJK(c) ? 2 : 1;
    runningLength += cLength;
  }
  return runningLength;
};

const restrictByHalfSpace = (string = '', length, originalString = '') => {
  if (halfSpaceLength(string, length) > length) {
    return originalString;
  } else {
    let newString = '';
    let sentenceLength = 0;
    for (let i = 0; i < string.length; i++) {
      const character = string[i];
      const characterLength = hasCJK(character) ? 2 : 1;
      if (characterLength + sentenceLength > length) {
        break;
      } else {
        newString += character;
        sentenceLength += characterLength;
      }
    }
    return newString;
  }
};

export default function useHalfSpace() {
  return {
    restrictByHalfSpace,
    halfSpaceLength,
  };
}
